import { SortingType } from '@/study-search/enums';

export class SortingOptionDefinition {
	public constructor(
		public readonly id: number,
		public readonly label: string,
		public readonly iconClass: string,
		public readonly type: SortingType,
	) {}
}
